import { WEBFLOW_SCRIPT_ENV } from '../src/webflow-script-env';
import { ATCUpsells } from './ATCUpsells';
import { checkoutUpsells } from './checkoutUpsell';
import { clearCart } from './clearCart';
import { getOnlyElementByAttribute } from './getOnlyElementByAttribute';

const checkoutDiv = getOnlyElementByAttribute(
  '[data-node-type="commerce-checkout-form-container"]'
) as HTMLElement;

const isCheckoutDivPresent = async () => {
  try {
    if (checkoutDiv) {
      if (WEBFLOW_SCRIPT_ENV !== 'production') {
        console.log('checkoutDiv present');
      }
      checkoutUpsells(checkoutDiv);
    } else {
      ATCUpsells();
    }
    clearCart();
  } catch (error) {
    throw error;
  }
};

isCheckoutDivPresent();
